import React, { ReactElement } from 'react';

import { CreditCalculationEstimate } from '../credit-calculation-estimate';
import { CreditCalculationForms } from '../credit-calculation-forms';
import { useFilingMethodForms } from './hooks/useFilingMethodForms';

export const CreditCalculationSection = (): ReactElement => {
  const { actualBusinessStartIsoDate, filingMethod, filingMethodForms, filingMethodProgress } = useFilingMethodForms();

  return (
    <>
      <CreditCalculationEstimate filingMethod={filingMethod} />
      <CreditCalculationForms
        actualBusinessStartIsoDate={actualBusinessStartIsoDate}
        filingMethod={filingMethod}
        filingMethodForms={filingMethodForms}
        filingMethodProgress={filingMethodProgress}
      />
    </>
  );
};
